import { render, staticRenderFns } from "./MigrationCreate.vue?vue&type=template&id=67010d63"
import script from "./MigrationCreate.vue?vue&type=script&lang=js"
export * from "./MigrationCreate.vue?vue&type=script&lang=js"
import style0 from "./MigrationCreate.vue?vue&type=style&index=0&id=67010d63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports